import { FormlyAttributeEvent } from '@ngx-formly/core/lib/models';

/**
 *
 * @param formlyEvent Keyboard event with formly wrapper
 * @param keyboardEvent JS keyboard event
 * @returns Formly Attribute Event
 *
 * Blocks any non integer input on formly field
 */
export const integerOnlyFormlyFilter = (formlyEvent, keyboardEvent): FormlyAttributeEvent => {
	// Whitelisted keys, using .key prop
	const allowedIntegerKeys = '0123456789';

	if (!allowedIntegerKeys.includes(keyboardEvent.key)) {
		keyboardEvent.preventDefault();
	}

	return formlyEvent;
};
